module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/banner/en-90f72c0f08cf11fdc10f386f9da33450.jpg";